import { Button, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import { useModalContext } from "../../providers";

import { Task } from "../../types/task";

const DeleteTaskButton = ({ task }: { task: Task }) => {
  const { setTask, openDeleteTask } = useModalContext();

  return (
    <Tooltip title="Esborrar tasca">
      <Button
        onClick={() => {
          setTask(task);
          openDeleteTask();
        }}
        icon={<DeleteOutlined />}
      />
    </Tooltip>
  );
};
export default DeleteTaskButton;
